const track = document.querySelector('[id^="ProductThumbnails-"]');
const prevBtn = document.querySelector(".product__thumbnails-prebtn");
const nextBtn = document.querySelector(".product__thumbnails-nextbtn");

const itemHeight = 76.25; // 71.25 + 5px 间距
const maxVisible = 6;
let index = 0;

// 获取当前显示的有效图片项
function getVisibleItems() {
    // return Array.from(track.querySelectorAll('.product__thumbnail.gang__active'))
    //     .filter(item => getComputedStyle(item).display !== 'none');

    // 1. 先看.product__thumbnail是否有[data-gang-option], 
    //      a.有的话要判断 .gang__active, 返回 .product__thumbnail.gang__active 的元素
    //      b. 没有的话直接返回所有的.product__thumbnail 元素

    const thumbs = Array.from(track.querySelectorAll('.product__thumbnail'));
    // 只要有任意一个缩略图带 data-gang-option，就算有，走上面的a逻辑
    const hasGangOption = !!track.querySelector('.product__thumbnail[data-gang-option]');

    const candidates = hasGangOption ? thumbs.filter(el => el.classList.contains('gang__active')) : thumbs;   

    // 保留可见项
    return candidates.filter(el => getComputedStyle(el).display !== 'none');
}

// 更新轮播图位置与按钮状态
function updateCarousel() {
    const items = getVisibleItems();
    const itemsCount = items.length;

    if (index > itemsCount - maxVisible) {
        index = Math.max(0, itemsCount - maxVisible);
    }

    track.style.transform = `translateY(-${index * itemHeight}px)`;
    prevBtn.disabled = index === 0;
    nextBtn.disabled = index >= itemsCount - maxVisible;
}

// 监听按钮点击
prevBtn.addEventListener("click", () => {
    index--;
    updateCarousel();
});

nextBtn.addEventListener("click", () => {
    index++;
    updateCarousel();
});

// 记录上一次展示的图片 ID（判断是否切换了variant）
let lastActiveIds = Array.from(getVisibleItems()).map(item => item.dataset.mediaId);

// MutationObserver：监听variant变化
const observer = new MutationObserver(() => {
    const currentItems = getVisibleItems();
    const currentIds = currentItems.map(item => item.dataset.mediaId);

    const hasChanged = currentIds.length !== lastActiveIds.length ||
        currentIds.some((id, i) => id !== lastActiveIds[i]);

    if (hasChanged) {
        index = 0;
        updateCarousel();
        lastActiveIds = currentIds;
    }
});

observer.observe(track, {
    subtree: true,
    attributes: true,
    attributeFilter: ['class']
});

// 初始化执行一次
updateCarousel();